import { render } from "./UrlCodec.vue?vue&type=template&id=0acfaf0e&scoped=true"
import script from "./UrlCodec.vue?vue&type=script&lang=js"
export * from "./UrlCodec.vue?vue&type=script&lang=js"

import "./UrlCodec.vue?vue&type=style&index=0&id=0acfaf0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acfaf0e"]])

export default __exports__